import React from "react";

import LeftSideImg from "./components/LeftSideImg";
import RightSideTxt from "./components/RightSideTxt";

function RecapComp() {
  return (
    <div className="recap-comp">
      <LeftSideImg />
      <RightSideTxt />
    </div>
  );
}

export default RecapComp;
